
















































import { Component } from "vue-property-decorator";
import { required } from "@/shared/validators";
import Modal from "@/shared/components/modal.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import ComboMotivoLead from "../components/ComboMotivoLead.vue";
import { LeadService, Lead } from "@/services/lead.service";

import ComboStatusLead from "../components/ComboStatusLead.vue";
import ConsultorAutoComplete from "@/shared/components/auto-complete/consultor/consultor-auto-complete.vue";

@Component({
  components: {
    Modal,
    ComboMotivoLead,
    ComboStatusLead,
    ConsultorAutoComplete,
  },
})
export default class MudarStatus extends mixins(GlobalMixin) {
  loading = false;
  lead: Lead = {} as Lead;
  observacao: string | null = null;
  idStatusLead: number | null = null;

  rules = {
    idStatusLead: [required()],
    idConsultor: [required()],
  };

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async mudarStatus(idLead: number) {
    this.lead.idLead = idLead;
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    return p;
  }

  async registrarMudanca() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      this.lead.idStatusLead = this.idStatusLead!;
      try {
        if (this.lead) {
          await LeadService.mudarStatus(this.lead, this.observacao);
          form.reset();
        }
        return modal.close(true);
      } finally {
        this.loading = false;
      }
    }
  }
}
